export default [
  {
    path: '/servicer',
    name: 'Servicer',
    component: () => import('@/layout'),
    redirect: '/servicer/servicer-list',
    meta: {
      title: '服务商管理',
    },
    children: [
      {
        path: 'servicer-list',
        name: 'ServicerList',
        component: () => import('@/views/web/servicer/servicer-list/list'),
        meta: {
          title: '服务商管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-22',
          trackName: '服务商管理 - 服务商管理',
          activeMenu: '/servicer/servicer-list',
        },
      },
    ],
  },
];

